export type FieldError = { readonly field: string; readonly message: string };

export function lengthError({
  field,
  label,
  value,
  max,
  min = 1,
}: {
  field: string;
  label: string;
  value: string;
  max: number;
  min?: number;
}): FieldError | null {
  const length = [...value.trim()].length;

  if (length < min || length > max) {
    return { field, message: `${label}: ${min}-${max} characters` };
  }

  return null;
}
